/**
 * AuditoriaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {Auditoria} from '@/model/resource/Auditoria'

/* TODO: review generated class */
@HttpExclude()
export class AuditoriaCollection extends PageCollection<Auditoria> {
  constructor() {
    super(Auditoria)
  }

  queryAsPage() {
    return this.listAuditoria()
  }

  async listAuditoria() {
    return await Request.get(`/admin/auditoria`, {params: this.params})
      .name('listAuditoria')
      .as(this)
      .getResponse()
  }

  async listCsvAuditoria() {
    return await Request.get(`/admin/auditoria/csv`, {params: this.params})
      .name('listCsvAuditoria')
      .as(this)
      .getResponse()
  }
}
